import { render, staticRenderFns } from "./champ_select.vue?vue&type=template&id=8e900fee&scoped=true"
import script from "./champ_select.js?vue&type=script&lang=js&external"
export * from "./champ_select.js?vue&type=script&lang=js&external"
import style0 from "./champ_select.vue?vue&type=style&index=0&id=8e900fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e900fee",
  null
  
)

export default component.exports